import { Button, DatePicker, Drawer, Form, Input, Select, Space } from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const SaveMerchantOrderUnsave = ({
  open,
  close,
  setLoading,
  getMerchantOrderUnsaveList,
  getMerchantOrderSaveList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });

  const handleSaveToMerchantOrder = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    // invoice_from
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/save-merchant-order-unsave", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to merchant order successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getMerchantOrderUnsaveList();
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const getMerchantList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/merchant-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantList();
  }, [getMerchantList]);

  return (
    <Drawer
      title="Save Prepared Merchant Order"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleSaveToMerchantOrder}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="merchant"
            label="Merchant"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select merchant"
              //   onChange={(e) => {
              //     handleFetchProduct(e);
              //   }}
              size="large"
              showSearch
            >
              {console.log("merchantList", merchantList.data)}
              {merchantList.data.length > 0 ? (
                merchantList.data.map((data, index) => (
                  <Select.Option value={data.user_id} key={index}>
                    {data.fullname}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="">No merchant found!</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item
            name="invoice_number"
            label="Invoice Number"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set Invoice" size="large" />
          </Form.Item>

          {/* <Form.Item
            name="invoice_from"
            label="Invoice From"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set Invoice From" size="large" />
          </Form.Item> */}

          <Form.Item
            name="invoice_date"
            label="Invoice Date"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"MM/DD/YYYY"}
              size="large"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SaveMerchantOrderUnsave;
